import jBob from "./jbob";

class Utils {
    static j()
    {
        if (typeof Utils.jbob == 'undefined') {
            Utils.jbob = new jBob();
        }

        return Utils.jbob;
    }
}

export default Utils;
